<template><div class="h-full text-center">Sobre</div></template>
